module.exports = __webpack_public_path__ + "img/pp2.7a6eb625.jpg";